import Swiper, {Navigation, Pagination, Scrollbar, Thumbs, Autoplay, Lazy} from 'swiper';
Swiper.use([Navigation, Pagination, Scrollbar, Thumbs, Autoplay, Lazy]);


export default class SwipersAbout{
    constructor() { 
        new Swiper(".syr_logo_photo_swiper", {
            loop: true,
            spaceBetween: 10,
            slidesPerView: 2, // Чтобы размер фоток был как в CSS, делаем auto
            lazy: {loadPrevNext: true},
            breakpoints: {
            480: {
                slidesPerView: 3,
                spaceBetween: 10
            },
            600: {
                slidesPerView: 3,
                spaceBetween: 15
            },
            979: {
                slidesPerView: 4,
                spaceBetween: 20
            }
            },
            navigation: {
                nextEl: ".syr_logo_photo_swiper_next",
                prevEl: ".syr_logo_photo_swiper_prev"
            },
        });


        const swiper = new Swiper('.obj_swiper_off', {
            loop: true,
            spaceBetween: 10,
            slidesPerView: 4,
            freeMode: true,
            watchSlidesProgress: true,
        });
        const swiper_ = new Swiper('.obj_swiper_main', {
            loop: true,
            spaceBetween: 10,
            slidesPerView: 1,
            navigation: {
              nextEl: ".production_photo_swiper_next_1",
              prevEl: ".production_photo_swiper_prev_1"
            },
            thumbs: {
              swiper: swiper,
            },
        });
    }


    
}



